// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/modules/components/jobdetails.less
// module id = 412
// module chunks = 0